export const newInvoiceTool = {
  CREATE_NEW_INVOICE: "Create New Invoice",
  PREVIOUS_INVOICING_TOOL: "Previous Invoicing Tool",
  EDIT_INVOICE: "Edit Invoice Request",
  VERSION_RESTRICTION_TITLE: "Version Restriction",
  VERSION_RESTRICTION_MESSAGE: "This invoice was created with Version 3 of the invoice tool. To edit this invoice, please switch to Version 3.",
  CLOSE: "Close",
  EDIT_REQUEST_INVOICE: "Edit Invoice Request",
  PREVIEW: "Preview",
  SAVE_DRAFT: "Save Draft",
  SAVE_AND_SHARE: "Save and share",
  ARE_YOU_SURE_YOU_WANT_TO_SAVE: "Are you sure you want to save the invoice?",
  SAVE_INVOICE: "Save Invoice",
  SEARCH_INVOICE_CLIENT: "Search invoice client...",
   BUSINESS_INFORMATION: "BUSINESS INFORMATION",
    CONTACT_INFORMATION: "CONTACT INFORMATION",
    PREFERENCES: "PREFERENCES",
  NEED_HELP: "Need help?",
  HELP_SUPPORT: "Help & Support",
  CHAT_WITH_US: "Chat with us",
  FAQ: "FAQ",
  USER_GUIDE: "User Guide",
  CREATE_NEW_INVOICE_PAGE_TITLE: "Create New Invoice",
  LOADING: "Loading...",
  DRAFT_INVOICE: "Draft Invoice",
  PRELIMINARY_INVOICE_PREVIEW: "Preliminary Invoice Preview",
  PRELIMINARY_INVOICE_PDF: "Preliminary Invoice PDF",
  NO_PDF_DATA_AVAILABLE: "No PDF data available",
  CHANGE_LOGO: "Change Logo",
  DROP_FILE_OR: "Drag and drop a file or click ",
  DROP_FILE_OR_NEXT: " to upload your company logo",
  BROWSE: "Browse",
  LOGO_FORMAT_INFO: "JPG/PNG only, Max 1MB, 160x50px recommended, transparent background preferred",
  LOGO_FORMAT_INFO_MOBILE: "JPG/PNG, Max 1MB",
  ATTACH_YOUR_LOGO: "Attach your logo",
  COPY_RECENT_INVOICE: "Copy Recent Invoice",
  COPY_RECENT: "Copy Recent",
  CALCULATED_AMOUNTS: "Calculated Amounts",
  NET: "Net",
  TAX: "Tax",
  TOTAL: "Total",
  PENSION: "Pension",
  HOLIDAY_PAY: "Holiday Pay",
  CUSTOMER_DETAILS: "Customer Details",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Customer updated successfully",
  FAILED_TO_UPDATE_CUSTOMER: "Failed to update customer. Please try again.",
  FAILED_TO_SAVE_CUSTOMER: "Failed to save customer. Please try again.",
  SUBMITTING: "Submitting...",
  EDIT_CUSTOMER: "Edit Customer",
  SELECT_CUSTOMER: "Select Customer",
  LOADING_CUSTOMERS: "Loading customers...",
  EDIT_CUSTOMER_MODAL_TITLE: "Edit Customer",
  SELECT_A_CUSTOMER: "Select a customer",
  ADD_NEW_CUSTOMER: "Add New Customer",
  CUSTOMER_ADDRESS: "Customer Address",
  NO_BILLING_ADDRESS_AVAILABLE: "No billing address available",
  EDIT: "Edit",
  CUSTOMER_ID: "Customer ID",
  NOT_SELECTED: "Not selected",
  YOUR_REFERENCE: "Your Reference",
  CUSTOMER_REFERENCE_NAME: "Customer Reference Name",
  ENTER_YOUR_REFERENCE_NO: "Enter your reference no.",
  ENTER_CUSTOMER_REFERENCE_NAME: "Enter customer reference name",
  SAVE: "Save",
  ADD_CUSTOMER_MODAL_TITLE: "Add New Customer",
  CANCEL: "Cancel",
  NEXT: "Next",
  BACK: "Back",
  UPDATING: "Updating...",
  CREATING: "Creating...",
  UPDATE_DETAILS: "Update Details",
  SAVE_DETAILS: "Save Details",
  FAILED_TO_SAVE_CUSTOMER: "Failed to save customer. Please try again.",
  FAILED_TO_CREATE_CUSTOMER: "Failed to create customer. Please try again.",
  
  // BusinessInformation translations
  BUSINESS_TYPE: "Business type",
  SELECT: "Select",
  PRIVATE_CUSTOMER: "Private Customer",
  BUSINESS_CUSTOMER: "Business Customer",
  BUSINESS_CONSTRUCTION: "Business Construction",
  CUSTOMER_FULL_NAME_BUSINESS_NAME: "Customer full name / Business name",
  TYPE_HERE: "Type here....",
  YOUR_12_DIGIT_SSN_NO: "Customer's social security number",
  ORGANIZATION_NUMBER: "Organization number",
  ONLY_NUMBERS_ALLOWED: "(Only numbers are allowed)",
  TYPE_NUMBER_ONLY: "Type number only...",
  COUNTRY: "Country",
  SWEDEN: "Sweden",
  USA: "USA",
  CANADA: "Canada",
  PANAMA: "Panama",
  NORWAY: "Norway",
  DENMARK: "Denmark",
  FINLAND: "Finland",
  COUNTRY_SELECTION_INFO: "When you select a country other than Sweden, your invoice will automatically be in English.",
  CITY: "City",
  ZIP_CODE: "ZIP code",
  BUSINESS_ADDRESS_LINE_1: "Business address line 1",
  BUSINESS_ADDRESS_LINE_2: "Business address Line 2",
  DOES_CUSTOMER_HAVE_VAT_REGISTRATION: "Does your customer have a VAT registration number?",
  YES: "Yes",
  NO: "No",
  VAT_NUMBER: "VAT number",
  VAT_COUNTRY_CODE_AUTO_ADD: "(We automatically add the country code.)",
  
  // ContactInformation translations
  CUSTOMER_REFERENCE_NAME_LABEL: "Customer reference name",
  CUSTOMER_REFERENCE_INFO: "Here, enter the name of the person who will approve your invoice or an order number.",
  CONTACT_EMAIL: "Contact email",
  CONTACT_EMAIL_INFO: "where your invoice will be sent. A copy is always sent to your own email.",
  CONTACT_PHONE_NUMBER: "Contact phone number",
  SELECT_INVOICE_LANGUAGE: "Please select your invoice language",
  SELECT_LANGUAGE_TYPE: "Select Language Type",
  SWEDISH: "Swedish",
  ENGLISH: "English",
  HOW_DO_YOU_WANT_INVOICE: "How the customer should receive the invoice?",
  SELECT_INVOICE_TYPE: "Select Invoice Type",
  EMAIL_SEND_TO_EMAIL: "Email (send to email address)",
  E_INVOICE_SEND_ELECTRONIC: "E-invoice (send as electronic invoice)",
  POST_60_SEK: "Post (60 SEK)",
  OUR_ELECTRONIC_REFERENCE: "Our electronic reference",
  YOUR_ELECTRONIC_REFERENCE: "Your electronic reference",
  GLN_PEPPOL_ID: "GLN / Peppol ID",
  EXTRA_FIELD_1_OPTIONAL: "Extra field 1 e-invoice (optional)",
  EXTRA_FIELD_2_OPTIONAL: "Extra field 2 e-invoice (optional)",
  CARE_OF: "C/O",
  
  // Email delivery options
  USE_EXISTING_EMAIL_ADDRESS: "Use existing email address",
  SECONDARY_EMAIL_ADDRESS: "Secondary Email Address",
   SECONDARY_EMAIL_REQUIRED: "Secondary email address is required",
  // Postal delivery options
  USE_EXISTING_ADDRESS: "Use existing address for postal delivery",
  POSTAL_ADDRESS: "Postal Address",
  POSTAL_CITY: "Postal City",
  POSTAL_COUNTRY: "Postal Country",
  POSTAL_ZIP_CODE: "Postal Zip Code",
  POSTAL_COUNTRY_CODE: "Postal Country Code",
  
  // Preferences translations
  PREFERENCES_DESCRIPTION: "Data entered here will be included on all invoices for this customer.",
  PAYMENT_TERMS: "Payment terms",
  PAYMENT_TERMS_INFO: "(specify 30 days unless you and the customer have agreed otherwise)",
  PAYMENT_TERM: "Payment Term",
  DAYS_7: "7 days",
  DAYS_14: "14 days",
  DAYS_30: "30 days",
  DAYS_60: "60 days",
  DAYS_90: "90 days",
  
  // Edit Billing Address Modal translations
  ADD_EDIT_BILLING_ADDRESS: "Add / Edit Billing Address",
  CUSTOMER_CREATED_SUCCESSFULLY: "Customer created successfully",
  STATE_COUNTY: "State / County",
  ENTER_HERE: "Enter here...",
  ADDRESS_LINE: "Address line",
  SUBMITS: "Save",
  STOCKHOLM: "Stockholm",
  GOTHENBURG: "Gothenburg",
  MALMO: "Malmö",
  UPPSALA: "Uppsala",
  UNITED_STATES: "United States",
  UNITED_KINGDOM: "United Kingdom",
  GERMANY: "Germany",
  FRANCE: "France",
  SPAIN: "Spain",
  ITALY: "Italy",
  NETHERLANDS: "Netherlands",
  BELGIUM: "Belgium",
  AUSTRALIA: "Australia",
  
  // Collective Invoice translations
  CREATE_COLLECTIVE_INVOICE: "Create Collective Invoice",
  SELECT_WEEK_OFF_DAYS: "Select Week-off days",
  ENTER_SERVICE_DESCRIPTION: "Enter service description",
  SERVICE_DESCRIPTION: "Service Description",
  SERVICE_DESCRIPTION_TOOLTIP: "Describe your service (max 42 characters). Only Latin characters are allowed (A-Z, a-z, 0-9, spaces, and common punctuation).",
  ONLY_LATIN_CHARACTERS_ALLOWED: "Only Latin characters are allowed",
  SERVICE_DESCRIPTION_MAX_CHARS: "Service description cannot exceed 42 characters",
  SELECT_DAYS: "Select Days",
  ADD_FREELANCERS_WORKING_WITH_YOU: "Add freelancers who are working with you for any project or any agency.",
  ADD_FRIENDS_WORKING_WITH_YOU: "Add your friends who are working with you for any project or any agency.",
  SEARCH_FREELANCERS_BY_EMAIL_NAME: "Search freelancers by email / name",
  ADD: "Add",
  ADD_COUNT: "Add ({{count}})",
  PLEASE_SELECT_CUSTOMER_FIRST: "Please select a customer first",
  SUGGESTIONS: "Suggestions",
  SELECT_ALL: "Select All",
  NO_FREELANCERS_FOUND: "No freelancers found matching \"{{searchValue}}\"",
  NO_FREELANCERS_AVAILABLE: "No freelancers available",
  INVITE_FREELANCERS_TO_INVOZIO: "Invite freelancers to Invozio to create collective invoices and earn extra Loyalty Points.",
  INVITE_FREELANCERS: "Invite Freelancers",
  INVITE_FREELANCER: "Invite freelancer",
  INVITE_FREELANCERS_WORKING_WITH_YOU: "Invite freelancers who are working with you for any project or any agency.",
  INVITE_FRIENDS_WORKING_WITH_YOU: "Invite your friends who are working with you for any project or any agency.",
  ENTER_FREELANCER_EMAIL: "Enter freelancer's email id here...",
  SENDING: "Sending...",
  
  // Invoice Preferences translations
  INVOICE_PREFERENCES: "Invoice Preferences",
  CURRENCY: "Currency",
  ENGAGEMENT_TYPE: "Engagement type",
  REGULAR_CONTINUOUS: "Regular / Continuous",
  OCCASIONAL_SPORADIC: "Occasional / sporadic",
  PRICING_TYPE: "Pricing Type",
  ADD_NEW_ROW: "Add New Row",
  HOURLY: "Hourly",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  AS_AGREED: "As agreed",
  VAT: "VAT",
  RUT_ROT_DEDUCTION_TYPE: "RUT/ROT Deduction type",
  ROT_DEDUCTION: "ROT Deduction",
  RUT_DEDUCTION: "RUT Deduction",
  NONE_REMOVE_RUT_ROT: "None (RUT/ROT)",
  ACCOMMODATION_TYPE: "Accommodation type",
  APARTMENT: "Apartment",
  HOUSE: "House",
  BRF_ORG_NUMBER: "Brf Org. Number",
  APARTMENT_HOUSE_NO: "Apartment / House No.",
  PROPERTY: "Property",
  ENTER_PROPERTY_DETAILS: "Enter property details",
  
  // Item Details translations
  ITEM_DETAILS: "Item Details",
  HOURS_PER_DAY: "Hours per day",
  SELECT_TYPE: "Select type",
  HOURLY_PRICE: "Hourly Price",
  DATES: "Dates",
  SELECT_DATES: "Select dates",
  SHOW_DATES: "Show Dates",
  SELECT_OPTION: "Select option",
  YES: "Yes",
  NO: "No",
  SERVICE_INVOICE: "Service invoice",
  WORKSHEET_PAY: "Worksheet pay",
  SELECT_ACCOMMODATION_TYPE: "Select accommodation type",
  HOTEL: "Hotel",
  OTHER: "Other",
  SELECT_ALLOWANCE: "Select allowance",
  HALF_DAY: "Half day",
  FULL_DAY: "Full day",
  CUSTOM_AMOUNT: "Custom amount",
  PLEASE_SELECT_WORK_DATES: "Please select work dates",
  PLEASE_ENTER_PRICE: "Please enter price",
  PRICE_MUST_BE_POSITIVE: "Price must be positive",
  
  // Auto Generate Items Modal
  AUTO_GENERATE_ITEMS: "Add Multiple Rows",
  HOURS_REQUIRED: "Hours per day is required",
  HOURS_INVALID_FORMAT: "Invalid time format. Use HH:MM",
  PRICE_REQUIRED: "Hourly price is required",
  PLEASE_SELECT_DATES: "Please select at least one date",
  TASK_DETAILS_REQUIRED: "Service description is required",
  GENERATE: "Generate",
  CANCEL: "Cancel",
  
  // Customer Validation Error Messages
  "Business type is required": "Business type is required",
  "Customer name is required": "Customer name is required",
  "SSN is required": "SSN is required",
  "SSN must be exactly 12 digits": "SSN must be exactly 12 digits",
  "The last 4 digits of SSN cannot be all zeros.": "The last 4 digits of SSN cannot be all zeros.",
  "Organization number is required": "Organization number is required",
  "Country is required": "Country is required",
  "Address is required": "Address is required",
  "City is required": "City is required",
  "ZIP code is required": "ZIP code is required",
  "VAT number is required": "VAT number is required",
  "Phone number is required": "Phone number is required",
  "Invoice delivery method is required": "Invoice delivery method is required",
  "Invoice language is required": "Invoice language is required",
  "Email is required": "Email is required",
  "Invalid email address": "Invalid email address",
  "Payment terms are required": "Payment terms are required",
  
  ACCOMMODATION_TYPE_LABEL: "Accommodation type",
  DATE_S: "Date(s)",
  ALLOWANCE_TYPE: "Allowance type",
  ATTACHMENT: "Attachment",
  PRICE: "Price",
  ACTIONS: "Actions",
  NO_FILE: "No file",
  FROM_INVOICE_PREFERENCES: "From Invoice Preferences",
  
  // Allowance Type Labels
  MILEAGE_REPORT: "Mileage Report",
  TRAVEL_EXPENSES: "Travel Expenses",
  MATERIALS_AND_TOOLS: "Materials & Tools",
  ALLOWANCE_OUTSIDE_SWEDEN: "Allowance Outside Sweden",
  ALLOWANCE_IN_SWEDEN: "Allowance In Sweden",
  
  WANT_TO_GET_PAID_FASTER: "Want to get paid faster? You can opt for",
  EXPRESS_PAYMENTS: "Express Payments",
  TO_SEE_MORE_DETAILS: "To see more details before you proceed",
  CLICK_HERE: "Click here",
  SUB_TOTAL: "Sub Total",
  VAT_LABEL: "VAT",
  TOTAL: "Total",
  SEE_HOW_WE_CALCULATED: "See how we calculated",
  CUSTOMER_WILL_PAY: "Customer will pay",
  
  // Services Table translations
  DATE_S_HEADER: "Date(s)",
  PRICING_TYPE: "Pricing Type",
  SERVICE: "Service",
  TIMES: "Time/Unit",
  UNITS: "Units",
  DISCOUNT: "Discount",
  SUBTOTAL: "Subtotal",
  SELECT_DATES_ABOVE: "Select dates above",
  GENERATE_ROW: "Select Date",
  HOURLY_WAGES: "Payment Per Hour",
  PAYMENT_PER_DAY: "Payment Per Day",
  PAYMENT_PER_WEEK: "Payment Per Week",
  PAYMENT_PER_MONTH: "Payment Per Month",
  PAYMENT_AS_AGREED: "Payment As Agreed",
  SEARCH_SELECT_SERVICE: "Search & select service",
  ENTER_SERVICE_NAME: "Enter service name",
  PLEASE_FILL_SERVICE_DESCRIPTION: "Please fill in service description for all working hours",
  PLEASE_SELECT_CUSTOMER_FIRST: "Please select a customer first",
  HH_MM: "HH:MM",
  ENTER_UNITS: "Enter units",
  VALUE: "Value",
  // ROT Service Types
  BUILD: "Build",
  ELECTRICITY: "Electricity",
  GLASS_SHEET_METAL: "Glass/sheet metal work",
  SOIL_DRAINAGE: "Soil / Drainage work",
  PAINTING_WALLPAPERING: "Painting / Wallpapering",
  PLUMBING: "Plumbing",
  MASONRY: "Masonry",
  // OTHER_COSTS: "Other costs",
  
  // RUT Service Types
  CLEANING: "Cleaning",
  TEXTILE_CLOTHING: "Clothing and textile care",
  SNOW_PLOWING: "Snow shoveling",
  GARDENING: "Gardening",
  BABYSITTING: "Child care",
  OTHER_CARE: "Personal care",
  MOVING_SERVICES: "Removal services",
  IT_SERVICES: "IT services",
  MAJOR_APPLIANCE_REPAIR: "Repair of white goods",
  FURNISHING: "Furnishings",
  HOME_MAINTENANCE: "Supervision of housing",
  TRANSPORTATION_SERVICES: "Transport services",
  WASHING_AND_CARE_OF_CLOTHING: "Washing and care of clothes",
  PDF_FILE_REQUIRED: "PDF file is required",
  
  // Pension and Holiday Section translations
  PENSION: "Pension",
  HOLIDAY_PAY: "Holiday pay",
  PENSION_ERROR_GROSS_SALARY: "The pension option is only available if the gross salary is 5000 SEK or more",
  AVAILABLE_ONLY_REGULAR_ENGAGEMENT: "Available only for Regular/Continuous engagement type",
  PENSION_NOTE_5000_SEK: "Note: The pension option is only available if the gross salary is 5000 SEK or more.",
  HOLIDAY_PAY_NOTE_190_SEK: "Note: 190 SEK will be deducted from each vacation payout.",
  PENSION_PAY: "Pension Pay",
  
  // Add Deduction Modal translations
  ADD_DEDUCTION: "Add Deduction",
  ADD_DEDUCTIONS: "Add Deductions",
  ITEM_DETAILS: "Item Details",
  SELECT_DEDUCTION_TYPE: "Select deduction type",
  PLEASE_SELECT_DEDUCTION_TYPE: "Please select deduction type",
  MILEAGE_REPORT: "Mileage Report",
  TRAVEL_EXPENSES_PDF: "Travel Expenses as per attached PDF",
  EXPENSES_MATERIALS_TOOLS_PDF: "Expenses for materials and tools as per attached PDF",
  ALLOWANCE_OUTSIDE_SWEDEN: "Allowance outside Sweden",
  ALLOWANCE_IN_SWEDEN: "Allowance in Sweden",
  PLEASE_SELECT_DEDUCTION_CONTINUE: "Please select a deduction type to continue",
  CANCEL: "Cancel",
  SUBMIT: "Submit",
  PLEASE_UPLOAD_PDF: "Please upload a PDF file",
  UPLOAD_ONLY_PDF: "Please upload only PDF files",
  FILE_SIZE_LESS_THAN_1MB: "File size must be less than 1 MB",

  // Mileage Report Form
  IS_MILEAGE_TAX_FREE: "Is the Mileage Report free of tax?",
  PLEASE_SELECT_OPTION: "Please select an option",
  SELECT_OPTION: "Select option",
  YES: "Yes",
  NO: "No",
  SHOW_MILEAGE_ON_INVOICE: "Do you want to show the Mileage Report on the invoice?",
  UPLOAD_FILE_PDF_1MB: "Upload File (PDF files up to 1 MB only)",
  CHANGE_PDF_FILE: "Change PDF File",
  UPLOAD_PDF_FILE: "Upload PDF File",
  KB: "KB",
  TRAVEL_DATE: "Travel Date",
  PLEASE_SELECT_TRAVEL_DATE: "Please select travel date",
  DISTANCE_KM: "Distance (in km)",
  PLEASE_ENTER_DISTANCE: "Please enter distance",
  ENTER_DISTANCE: "Enter distance",
  REASON_FOR_TRIP: "Reason For Trip",
  PLEASE_ENTER_REASON: "Please enter reason for trip",
  WRITE_HERE: "Write here...",
  CAR_REGISTRATION: "Car Registration No.",
  PLEASE_ENTER_CAR_REG: "Please enter car registration",
  CAR_REG_PLACEHOLDER: "XXXX XXXX",
  TRIP_STARTED_PLACE: "Trip Started Place",
  PLEASE_ENTER_START_PLACE: "Please enter trip started place",
  ALLOWANCE_PER_KM: "Allowance per km: 2.50 Kr",
  TOTAL: "Total",
  KR: "Kr",

  // Travel Expenses Form
  SHOW_TRAVEL_EXPENSES_ON_INVOICE: "Do you want to show the Travel Expenses on the invoice?",
  SHOW_ON_INVOICE_QUESTION: "Show on invoice?",
  VAT: "VAT",
  PLEASE_SELECT_VAT: "Please select VAT",
  SELECT_VAT: "Select VAT",
  VAT_0: "0%",
  VAT_6: "6%",
  VAT_12: "12%",
  VAT_25: "25%",
  AMOUNT_SEK_EX_VAT: "Amount in SEK (ex. VAT)",
  PLEASE_ENTER_AMOUNT: "Please enter amount",
  ENTER_AMOUNT: "Enter amount",
  TOTAL_INC_VAT: "Total (inc. VAT):",
  SEK: "SEK",

  // Materials & Tools Form
  IS_MATERIALS_TAX_FREE: "Is the Expenses for materials and tools free of tax?",
  SHOW_MATERIALS_ON_INVOICE: "Do you want to show the Expenses for materials and tools on the invoice?",
  DATE_OF_PURCHASE: "Date of Purchase",
  PLEASE_SELECT_PURCHASE_DATE: "Please select purchase date",

  // Allowance Outside Sweden Form
  IS_ALLOWANCE_OUTSIDE_TAX_FREE: "Is the Allowance outside Sweden free of tax?",
  SHOW_ALLOWANCE_OUTSIDE_ON_INVOICE: "Do you want to show the Allowance outside Sweden on the invoice?",
  TRIP_STARTED_DATE: "Trip Started Date",
  PLEASE_SELECT_START_DATE: "Please select start date",
  TRIP_ENDED_DATE: "Trip Ended Date",
  PLEASE_SELECT_END_DATE: "Please select end date",
  END_DATE_AFTER_START: "End date must be after start date",
  COUNTRY: "Country",
  PLEASE_SELECT_COUNTRY: "Please select country",
  SELECT_COUNTRY: "Select country",
  DESTINATION: "Destination",
  PLEASE_ENTER_DESTINATION: "Please enter destination",
  TRAVEL_DAYS: "Travel days",
  ALLOWANCE_PER_DAY: "Allowance per day",

  // Allowance In Sweden Form
  IS_ALLOWANCE_SWEDEN_TAX_FREE: "Is the Allowance in Sweden free of tax?",
  SHOW_ALLOWANCE_SWEDEN_ON_INVOICE: "Do you want to show the Allowance in Sweden on the invoice?",
  PARTIAL_WORKDAY_QUESTION: "Will this be a partial workday?",
  SWEDEN: "Sweden",
  SUMMARY: "Summary",

  // Other Details Component
  OTHER_DETAILS: "Other Details",
  CUSTOMER_NOTES: "Customer Notes",
  PLEASE_ENTER_DESCRIPTION_BEFORE_CREATING_INVOICE: "Please enter description before creating invoice",
  THANKS_FOR_BUSINESS: "Please describe here the type of work you have done for both us and your customer.",
  ADD_SUPPORTING_FILE: "Add supporting file",
  BROWSE_FILES: "Browse files",
  COMMUNICATION_EMAILS: "Communication Email(s)",
  ENTER_EMAIL_ID: "Enter email id",
  ADD: "Add",
  DESCRIPTION: "Description",

  // Invoice Footer Component
  GRAND_TOTAL: "Grand Total :",
  SENDING: "Sending...",
  SEND_INVOICE: "Send Invoice",
  // LOADING_INVOICE_DATA: "Loading invoice data...",
  INVOICE_DATA_LOADED: "Invoice data loaded.",
  FAILED_TO_LOAD_INVOICE_DATA: "Failed to load invoice data. Please try again.",

  // Copy invoice modal
  SELECT_AND_COPY: "Select & Copy",

  // Calculation Breakdown Modal
  CALCULATION_BREAKDOWN: "Calculation Breakdown",
  DRAFT_INVOICE_DATA_LOADED: "Draft invoice data loaded.",
  DRAFT_INVOICE_SAVED_SUCCESSFULLY: "Draft invoice saved successfully!",
  TOTAL: "Total",
  SHOW_SEPARATELY: "Show Separately",
  SUMMARY: "Summary",
  GROSS_SALARY: "Gross Salary",
  NET_SALARY: "Net Salary",
  INVOICE_VALUE: "Invoice Value",
  TOTAL_AMOUNT_INC_VAT: "Total Amount (Inc VAT)",
  DETAILED_BREAKDOWN: "Detailed Breakdown",
  COMPONENT: "Component",
  AMOUNT: "Amount",
  BASE_AMOUNT: "Base Amount",
  VAT: "VAT",
  AMOUNT_INC_VAT: "Amount Inc VAT",
  FAKTURA_FEE: "Faktura Fee",
  SOCIAL_FEE: "Social Fee",
  TO_PAY: "To Pay",
  EXPRESS_FEE: "Express Fee",
  ADDITIONAL_DETAILS: "Additional Details",
  CURRENCY: "Currency",
  LOYALTY_DISCOUNT: "Loyalty Discount",
  WORKING_DAYS: "Working Days",
  FREELANCERS: "Freelancers",
  CALCULATION_NOTE: "This breakdown shows how your total invoice amount is calculated based on the base amount, VAT, fees, and deductions.",
  NO_CALCULATION_DATA: "No calculation data available",
  NO_CALCULATION_DATA_DESC: "Please ensure you have entered all required information and try again.",
  CLOSE: "Close",
  PRINT: "Print",
  SEE_HOW_WE_CALCULATED: "See how we calculated",
  HOLIDAY_SAVINGS: "Holiday Savings",
  PENSION: "Pension",
  TAX: "Tax",
  INVOICE_AMOUNT_INC_VAT: "Invoice amount inc. VAT",
  INVOICE_AMOUNT_EX_VAT: "Invoice amount ex. VAT",
  INVOZIO_PERCENT_FEE: "Invozio percent fee",
  PENSION_SOCIAL_FEE: "Pension Social Fee",
  GROSS_SALARY_INCL_HOLIDAY_PAY: "Gross salary incl. holiday pay",
  HOLIDAY_PAY: "Holiday Pay",
  TOTAL_WORKING_HOURS: "Total Working Hours",
  AMOUNT_AFTER_TAXES: "Amount after taxes",
  NET_SALARY_INCL_HOLIDAY_PAY: "Net salary incl. holiday pay",
  
  // Calculation Breakdown Modal
  HOW_WE_CALCULATE_YOUR_INVOICE: "How We Calculate Your Invoice",
  INVOICE_DETAILS: "Invoice Details",
  INVOICE_AMOUNT_INCLUDING_VAT: "Invoice Amount (Including VAT)",
  INVOICE_AMOUNT_EXCLUDING_VAT: "Invoice Amount (Excluding VAT)",
  FEES: "Fees",
  INVOZIO_FEE: "Invozio Fee",
  SOCIAL_FEES: "Social Fees",
  SALARY_COMPONENTS: "Salary Components",
  GROSS_SALARY_INCLUDING_HOLIDAY_PAY: "Gross Salary (Including Holiday Pay)",
  TAX_INFORMATION: "Tax Information",
  INCOME_TAX: "Income Tax",
  INVOICE_SUMMARY: "Invoice Summary",
  PENSION_CONTRIBUTION: "Pension Contribution",
  RUT_DEDUCTION_AMOUNT: "RUT Deduction Amount",
  ROT_DEDUCTION_AMOUNT: "ROT Deduction Amount",
  EXPENSE: "Expense",
  ADMINISTRATOR_FEE: "Administrator Fee",
  ALLOWANCE: "Allowance",
  ADDITIONAL_INFORMATION: "Additional Information",
  LOYALTY_DISCOUNT_ON_INVOZIO_FEE: "Loyalty discount on Invozio's fee",
  HOURS: "Hours",
   NO_RESULTS_FOUND: "No results found",

  // Tooltip translations
  CURRENCY_TOOLTIP: "Choose the currency in which your invoice will be sent.",
  VAT_TOOLTIP: "Specify the VAT rate that applies to your service or product.",
  ENGAGEMENT_TYPE_TOOLTIP: "Select whether your work is continuous (ongoing) or occasional (one-time) — this affects how your engagement is categorized in invoicing.",
  PRICING_TYPE_TOOLTIP: "Choose how your pricing is calculated — for example, based on time or a fixed rate.",
  HOURS_PER_DAY_TOOLTIP: "Enter the number of hours you typically work per day for this project.",
  HOURLY_PRICE_TOOLTIP: "Set the amount you charge per hour of work.",
  RUT_ROT_DEDUCTION_TYPE_TOOLTIP: "Select the deduction type that applies if your service qualifies for Swedish RUT or ROT tax reductions.",
  DATES_TOOLTIP: "Indicate the dates when the work was performed.",
  CALENDAR_TOOLTIP: "Click to select a date. Drag to select multiple dates.",
  SHOW_DATES_TOOLTIP: "Toggle whether the work dates should be displayed on the invoice.",
  PENSION_PAY_TOOLTIP: "Optionally allocate part of your payment (0–3,000 SEK) to your occupational pension with our partner SPP.",
  HOLIDAY_PAY_TOOLTIP: "Set aside 0–50% of your salary as holiday pay. You can view and withdraw your saved holiday funds anytime under \"Salary Notices\".",
  
  // Currency Info Modal
  CURRENCY_INFO_MODAL_TITLE: "How we calculate the currency rates",
  CURRENCY_INFO_MODAL_MAIN_TEXT: "You can invoice in EUR, USD, GBP, CHF, CAD, AUD, NOK, DKK, JPY, and CNY. All salaries are paid in SEK. We apply a fixed 0.5% currency margin when converting to SEK, which covers the cost charged by the banks and secures the exchange rate for your salary.",
  CURRENCY_INFO_MODAL_ADDITIONAL_INFO: "The exact SEK amount, after conversion and margin, is always visible in your salary slip under Invoices.",
  CURRENCY_INFO_MODAL_CONTACT_TEXT: "Contact us if you have any questions",
  CURRENCY_INFO_MODAL_CONTACT_EMAIL: "support@invozio.com",

  // VAT Info Modal
  VAT_INFO_MODAL_MAIN_TEXT: "The Swedish Tax Agency's main rule is that goods and services invoiced within Sweden have a VAT surcharge of 25%. However, there are a few exceptional cases where the tax rate can be 12%, 6% or 0%.",
  VAT_INFO_MODAL_EXAMPLE: "Examples of extraordinary circumstances with 6% VAT are copyrighted material.",
  VAT_INFO_MODAL_NOTE_TITLE: "Please note:",
  VAT_INFO_MODAL_NOTE_TEXT: "This rule does not apply to VAT-exempt artistic activities. If you issue invoices for artistic performances or related services, 25% VAT must be applied.",
  VAT_INFO_MODAL_EXEMPTION_TEXT: "Exports, work in international waters, CSN-eligible education, and certain types of healthcare are VAT exempt. Artist and musician gages have a 25% VAT surcharge, except when the artist or musician owns the invoicing company, in which case the gages are VAT exempt. If you are unsure which VAT rate applies to your work, don't hesitate to contact us at",
  
  // File upload error messages
  FILE_UPLOAD_PDF_ONLY: "Please upload only PDF files",
  FILE_UPLOAD_MAX_SIZE: "File size must not exceed 1 MB",
  FILE_SELECTED: "File selected",
  NO_FILE_SELECTED: "No file selected",

  // Invoice Preview Modal translations
  IN_DRAFT: "In Draft",
  DOWNLOAD: "Download",
  PRINT: "Print",
  SEND_INVOICE: "Send Invoice",
  ADDED_ATTACHMENT: "Added Attachment",
  CLICK_TO_VIEW_ATTACHMENT: "Click to view attachment",
  PREVIEW_INVOICE: "Preview Invoice",
  
  // Express Payment Modal translations
  EXPRESS_PAYMENT_REQUIREMENTS: "Express Payment Requirements",
  EXPRESS_PAYMENT_INFO_TEXT_1: "Express Payment requires an Approved credit status for both you and your customer. We run a UC check the first time and for each new customer, plus an initial and occasional delivery check to confirm the invoice.",
  EXPRESS_PAYMENT_INFO_TEXT_2: "Payment is made the same day once all checks are completed. If the customer confirms before 14:00, we aim to pay the same day or next morning after weekends/holidays. The fee is 5.9% (min. 590 SEK), compared to 1.4% with standard payment.",
  EXPRESS_PAYMENT_REQUIREMENTS_TEXT: "Requirements: no payment remarks, customer registered with Bolagsverket, work under 30 days old, invoice approved, no disputes. Not available for private individuals or sole proprietorships. Max invoice amount: 60,000 SEK.",
  GOT_IT: "Got it",

  // Bank Information translations
  "Please Add Your Bank Information": "Please Add Your Bank Information",
  "It looks like you forgot to enter your bank details. To complete your setup and receive payments, you can securely enter them here to receive payments and complete your setup.": "It looks like you forgot to enter your bank details. To complete your setup and receive payments, you can securely enter them here to receive payments and complete your setup.",
  "Bank": "Bank",
  "Bank Name": "Bank Name",
  "Your Bank Name Here": "Your Bank Name Here",
  "IBAN Number": "IBAN Number",
  "BIC Number": "BIC Number",
  "Clearing number": "Clearing number",
  "Account number": "Account number",
  "Note: Clearing number should be between 4-5 digits and account number can have maximum 10 digits. Special characters are not allowed.": "Note: Clearing number should be between 4-5 digits and account number can have maximum 10 digits. Special characters are not allowed.",
  "Save Settings": "Save Settings",

  // Auto Generate Items Modal translations
  AUTO_GENERATE_ITEMS: "Auto Generate Line Items",
  AUTO_GENERATE_DESCRIPTION: "Configure the parameters to automatically generate invoice line items for selected dates.",
  SELECT_DATES: "Select Dates",
  CLICK_TO_SELECT_DATES: "Click to select dates",
  HOURS_PER_DAY: "Hours per Day",
  PRICE: "Hourly Price",
  PRICING_TYPE: "Price Type",
  ENTER_AMOUNT: "Enter amount",
  CHARACTERS: "characters",
  GENERATES: "Generate Items",
  PLEASE_SELECT_DATES: "Please select at least one date",
  HOURS_REQUIRED: "Hours per day is required",
  HOURS_INVALID_FORMAT: "Invalid time format. Use HH:MM",
  PRICE_REQUIRED: "Hourly price is required",
  PRICE_MUST_BE_POSITIVE: "Price must be greater than 0",
  TASK_DETAILS_REQUIRED: "Service description is required",
  ARE_YOU_SURE_YOU_WANT_TO_SAVE: "Are you sure you want to save the invoice?",
  SAVE_INVOICE: "Save Invoice",
  SUMMARY_GENERATE_TEXT: "This will generate",
  SUMMARY_LINE_ITEM: "line item",
  SUMMARY_LINE_ITEMS: "line items",
  SUMMARY_EACH_WITH: "each with",
  SUMMARY_HOURS_AT: "hours at",
  ESTIMATED_TOTAL: "Estimated Total",
  MINIMUM_INVOICE_AMOUNT_ERROR: "Minimum 1000 SEK amount is required to create an invoice",
  
  // Logo upload toast messages
  LOGO_FORMAT_NOT_SUPPORTED: "Logo format not supported, only jpg or png are allowed",
  FILE_TOO_LARGE_1MB: "File too large. The maximum allowed size is 1 MB",
  LOGO_UPLOADED_SUCCESSFULLY: "Logo uploaded successfully",
  FAILED_TO_UPLOAD_LOGO: "Failed to upload logo",
  USER_NOT_FOUND: "User not found",
  LOGO_DELETED_SUCCESSFULLY: "Logo deleted successfully",
  FAILED_TO_DELETE_LOGO: "Failed to delete logo",
  
  // Invoice data toast messages 
  FAILED_TO_LOAD_INVOICE: "Failed to load invoice",
  FAILED_TO_CALCULATE_INVOICE: "Failed to calculate invoice",
  PLEASE_SELECT_CUSTOMER: "Please select a customer",
  PLEASE_ENTER_VALID_AMOUNT: "Please enter a valid amount",
  INVOICE_DATA_COPIED_SUCCESSFULLY: "Invoice {{invoiceNumber}} data copied successfully",
  FAILED_TO_COPY_INVOICE_DATA: "Failed to copy invoice data",
  INVOICE_SELECTED: "Invoice {{invoiceNumber}} selected",
  REMOVE_FREELANCER_TITLE: "Remove freelancer from this collective invoice?",
  
  // Remove freelancer modal translations
  REMOVE_FREELANCER: "Remove Freelancer",
 CONFIRM_REMOVE_FREELANCER_MESSAGE: "Removing <strong>{{name}}</strong> from this collective invoice will delete all their invoice activity data here (dates, hours, discounts).<br/><br/>This can't be undone. Continue?",
  CANCEL_BUTTON: "Cancel",
  REMOVE_FREELANCER_BUTTON: "Remove Freelancer",
   NO_CANCEL: "No, Cancel",
  YES_REMOVE: "Yes, Remove",
   INVITE_FREELANCER_FIRST_ERROR: "No freelancer found. Please invite the freelancer first, then you can add them.",
  INVOICE_EDITED_SUCCESSFULLY: "Invoice edited successfully",
  INVOICE_SAVE_ERROR_500: "Something went wrong while saving invoice, this invoice has been cancelled. Please try again.",
  
  // Bank details message
  "Your bank details has been added.": "Your bank details has been added.",
  
  // 401 Error message
  UPDATE_EMAIL_TO_CONTINUE: "Please update your email address in your account setting to continue.",
  
  // VAT validation errors
  INVALID_VAT_FORMAT_EXPECTED: "Invalid VAT number format. Expected format: {{format}}",
  INVALID_VAT_FORMAT_LENGTH: "Invalid VAT number format. It should be between {{min}} and {{max}} digits long.",
  INVALID_VAT_NUMBER_ERROR: "Request failed: Invalid VAT number.",
  
  // Invoice creation success messages
  INVOICE_CREATED_SUCCESSFULLY: "Invoice created successfully",
  PRELIMINARY_INVOICE_CREATED_SUCCESSFULLY: "Preliminary invoice created successfully",
};
